import { render, staticRenderFns } from "./EditPurchasesInvoiceComponent.vue?vue&type=template&id=dc6178e6"
import script from "./EditPurchasesInvoiceComponent.vue?vue&type=script&lang=js"
export * from "./EditPurchasesInvoiceComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports